class UnitToggle extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      checkbox: '[data-unit-toggle]',
      measurementElem: '[data-static-measurement]',
    };

    this.checkbox = this.querySelector(this.selectors.checkbox);
    this.measurementElems = this.container?.querySelectorAll(this.selectors.measurementElem);
  }

  connectedCallback() {
    if (!this.checkbox) return;

    this.checkbox.addEventListener('change', () => {
      const unit = this.checkbox.checked ? 'in' : 'cm';

      this.measurementElems?.forEach((element) => {
        const newValue = element.getAttribute(`data-measurement-${unit}`);
        if (!newValue) return;
        element.textContent = newValue;
      });

      // Notify components about unit change
      ['product-measurements', 'measuring-guide'].forEach((customElement) => {
        this.container?.querySelectorAll(customElement)?.forEach((element) => {
          element.dispatchEvent(new CustomEvent('size-guide:unit-change', {detail: {unit}}));
        });
      });
    });
  }
}

export default function initUnitToggle(container = document) {
  UnitToggle.prototype.container = container;

  if (!customElements.get('unit-toggle')) {
    customElements.define('unit-toggle', UnitToggle);
  }
}
